

window.addEventListener("load", function () {
	const languageSubMenuLinks = document.querySelectorAll(
		"#vxphl-ld-25-a-header .language-switch .sub-menu a"
	);

	languageSubMenuLinks.forEach(function (link) {
		link.addEventListener("click", function (event) {
			// Keep link navigation and avoid bubbling to MJ__toogleActive handler.
			event.stopPropagation();
		});
	});

});
